import BoProptradingTable from './BoProptradingTable';

export default BoProptradingTable;
